import { getObjValue } from '@hlj/hlj-utils'
export const plusMinus = (string = '', color = {}) => {
  if (string.indexOf('%') > -1) {
    string = string.substr(0, string.length - 1)
  }
  if (+string < 0) {
    return getObjValue(color, 'g') || '#2FC286'
  } else if (+string > 0) {
    return getObjValue(color, 'r') || '#FF801A'
  } else {
    return getObjValue(color, 'd') || '#595959'
  }
}
